import React from 'react';
import { Form } from 'fw/forms';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, FormGroup } from 'react-bootstrap';
import { ContentBody, VeteranAppIdHeader } from 'areas/shared/components';
import { Label, Button } from 'fw/components';
import { DocumentUpload } from 'areas/shared/controls';
import API from 'fw/system/API';
import * as FormManager from 'fw/forms/form/FormManager';
import { TooltipCode } from 'areas/shared/consts';

class Declaration extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState = () => {
        return {
            form: this.props.stepData,
            tooltips: this.props.stepInfo.tooltips
        };
    };

    updatePostData = (form, dirty) => {
        this.setState({ form });
        this.props.onStepChange(form);

        if (dirty === true)
            FormManager.dirt(this._form);
    }

    handleUploadChange = (file) => {
        let form = this.state.form;

        form.declarationStorageToken = file.storageToken;
        form.declarationFileName = file.fileName;

        this.updatePostData(form, true)
    };

    downloadDeclarationForm = () => {
        new API().download({
            storageToken: this.state.form.declarationFormStorageToken,
            fileName: this.state.form.declarationFormFileName
        });
    };

    setTip = (property) => {
        const tooltip = this.state.tooltips.find(t => t.code === property)
        return tooltip !== undefined ? tooltip.tip : null
    }

    render() {
        return (
            <ContentBody>
                <Form
                    onChange={this.updatePostData}
                    values={this.state.form}
                    unsavedChangesWarning={true}
                    ref={(form) => { this._form = form }}>
                    <Row>
                        <Col md={12}>
                            <Row>
                                <Col md={12}>
                                    <h3 style={{ position: 'relative' }}>Please print and complete the Declaration Form - Upload when completed <VeteranAppIdHeader appId={this.state.form.certificationId} daysOpen={this.props.stepInfo.daysOpen} /></h3>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <p>
                                        I (we) have completed and submitted the information as requested by the National Veteran Business Development
                                        Council and hereby certify that the information contained herein and in all attachments and supporting
                                        documents are true, correct, and accurate to the best of my (our) knowledge and belief. I (we) understand that
                                        this Declaration of Certification of Veteran Status and the criteria set forth have been developed according
                                        to the guidelines established by the National Veteran Business Development Council. The certification, when
                                        granted, will be for a one (1) year term. I (we) further understand that completion and submission of this
                                        form, together with all attachments and supporting documents hereto, is not necessarily the sole criteria for
                                        determining certification of veteran status; additional documents may be required by the National Veteran
                                        Business Development Council.
                                    </p>
                                    <p>
                                        I (we) acknowledge that if the NVBDC discovers that a statement has been made therein which the applicant
                                        knows to be false, the certification process will be terminated immediately. I (we) agree that all materials
                                        submitted with this application shall become the property of the NVBDC and that all submitted documentation
                                        will be held in strict confidence.
                                    </p>
                                    <p>
                                        I (we) further agree that once certified, the continued certification and registration by the NVBDC will be
                                        according to the guidelines, rules, and regulations of the NVBDC and may be amended from time to time.
                                        Termination of my (our) status may be based upon, but not necessarily limited to, any one of the following:
                                    </p>
                                    <p>
                                        1. Cessation of operation by the veteran business.
                                        <br />
                                        2. Discovery that any false information was knowingly supplied to the NVBDC in the completion of this form or
                                        as contained in any submitted attachments or supporting documents.
                                        <br />
                                        3. Failure to provide timely notice or withholding of any notice to the NVBDC of the transfer or loss of
                                        ownership and/or management and control of the business by its veteran group members.
                                        <br />
                                        4. Failures or refusal to allow the NVBDC and/or its authorized representatives access to the company's place
                                        of business upon reasonable notice and demand for the purpose of a site visit.
                                        <br />
                                        5. Sales, exchange, or transfer of ownership of the veteran business, if such transfer results in the loss of
                                        control and ownership of the business by the veteran group members.
                                    </p>
                                    <p>
                                        I (we) understand and agree that the NVBDC reserves the right to request any further and additional
                                        information that may be necessary to substantiate the information and representations made by the applicant(s)
                                        for certification. I (we) declare that the company in whose name this application is being submitted is at
                                        least fifty-one percent (51%) owned by one or more veteran individuals (as defined therein) and such
                                        individuals control, operate, and manage the company.
                                    </p>
                                    <p>
                                        The undersigned hereby agrees (agree) to hold the NVBDC free and harmless from any and all claims, demands,
                                        and damages whatsoever arising from the presentation of this application and agrees to indemnify and hold the
                                        NVBDC harmless for any and all liability in connection with the certification of the information contained in
                                        this application.
                                    </p>
                                    <p>
                                        The undersigned hereby declares (declare) under penalty of perjury that I (we) have read this Declaration of
                                        Certification of Veteran Status completely and all statements made in this application and any attachments and
                                        supporting documents hereto are true and correct. I (we) understand that the registration fee is included and
                                        non-refundable.
                                    </p>
                                    <p>
                                        <br />
                                    </p>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={2}>
                                    <div>
										<Button type="button" bsStyle="link" onClick={() => this.downloadDeclarationForm()}>
                                            Download Declaration
                                                <br />
                                            <FontAwesomeIcon icon={faPrint} size='3x' color='black' style={{ textAlign: 'center' }} />
										</Button>
                                    </div>
                                </Col>
                                <Col md={6}>
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label htmlFor="declarationUpload" tip={this.setTip(TooltipCode.DECLARATION.DECLARATIONCERUPLOAD)} required>Declaration of Certification Upload</Label>
                                        <DocumentUpload
                                            storageToken={this.state.form.declarationStorageToken}
                                            fileName={this.state.form.declarationFileName}
                                            onChange={file => this.handleUploadChange(file)}
                                            wrapFileNameLength={30}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <p>
                                    <br />
                                </p>
                            </Row>
                        </Col>
                    </Row>
                </Form >
            </ContentBody>
        );
    }
}

export default Declaration;



// WEBPACK FOOTER //
// ./src/areas/certification/steps/declaration/Declaration.js